<table class="ui selectable celled table">
  <thead>
  <tr>
    <th i18n="@@title">Titel</th>
    @if (showDescription) {
      <th i18n="@@article-list-description">Beschreibung</th>
    }
    @if (showDeadlines) {
      <th i18n="@@article-list-deadline">Frist</th>
    }
    @if (showLinks) {
      <th>Links</th>
    }
    @if (showAuthor) {
      <th i18n="@@author">Autor</th>
    }
    @if (showUpdatedAt) {
      <th i18n="@@article-list-edited">Erstellt/Bearbeitet</th>
    }
    @if (showActions) {
      <th i18n="@@article-list-actions">Aktionen</th>
    }
  </tr>
  </thead>
  <tbody>
    @for (article of articles; track article._id) {
      <tr [routerLink]="showActions ? null : ['/articles', article._id]">
        <td>
          {{ article | i18nSelect:'title':'englishTitle' }}
          @if (article.isDraft) {
            <span class="ui yellow label" i18n="@@article-draft">Entwurf</span>
          }
        </td>
        @if (showDescription) {
          <td>
            <div [innerHTML]="(article | shortDescription)"></div>
          </td>
        }
        @if (showDeadlines) {
          <td>
            <ul class="ui relaxed bulleted list">
              @for (deadline of article.deadlines; track deadline) {
                <li class="item" i18n="@@articles-until">{{ deadline | i18nSelect:'title':'englishTitle' }} bis zum {{ deadline.date | date}}</li>
              }
            </ul>
          </td>
        }
        @if (showLinks) {
          <td>
            <ul class="ui relaxed bulleted list">
              @for (link of article.links; track link) {
                <li class="item">
                  <a [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.label || link.url }}</a>
                </li>
              }
            </ul>
          </td>
        }
        @if (showAuthor) {
          <td>
            {{ article.author?.firstname }} {{ article.author?.lastname }}
            @if (article.author?.email) {
              <br>
              ({{ article.author?.email }})
            }
          </td>
        }
        @if (showUpdatedAt) {
          <td>
            {{ article.updatedAt | date }}
          </td>
        }
        @if (showActions) {
          <td>
            @if (article.isDraft) {
              <a
                class="ui yellow icon button"
                routerLink="/articles/{{ article._id }}"
                data-tooltip="Vorschau anzeigen"
                i18n-data-tooltip="@@article-list-show-draft"
              >
                <i class="icon eye"></i>
              </a>
            } @else {
              <a class="ui secondary icon button" routerLink="/articles/{{ article._id }}" data-tooltip="Anzeigen"
                 i18n-data-tooltip="@@article-list-show">
                <i class="icon eye"></i>
              </a>
            }
            <a class="ui primary icon button" routerLink="edit/{{ article._id }}" data-tooltip="Bearbeiten"
               i18n-data-tooltip="@@article-list-edit">
              <i class="icon edit"></i>
            </a>
            <button class="ui red icon button" (click)="delete(article)" data-tooltip="Löschen"
                    i18n-data-tooltip="@@article-list-delete">
              <i class="icon trash"></i>
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
